import { createSelector } from 'reselect';
import { PlatformEnvironment } from '@mews/enums';
import { composeProps, createPropsExtender, ifProps } from '@mews/framework';
import { getPageFormatByServiceId } from '@mews-commander/legacy-entities/src/ducks/registrationCardConfigurations';
import {
    getCurrentEnterpriseReservationAssignedResourceId,
    getCurrentEnterpriseReservationServiceId,
} from '@mews-commander/legacy-entities/src/selectors/reservations';
import { getPlatformEnvironment } from '../../../app/reducers/configuration';
import { getCurrentEnterpriseResourceState } from '../ResourcesSection/selectors';

export const getCurrentEnterpriseReservationAssignedResourceState = composeProps(
    getCurrentEnterpriseResourceState,
    createPropsExtender('resourceId', getCurrentEnterpriseReservationAssignedResourceId)
);

export const getPageFormatByReservationId = composeProps(
    ifProps(['serviceId'], getPageFormatByServiceId),
    createPropsExtender('serviceId', getCurrentEnterpriseReservationServiceId)
);

export const getOakyUpsellingClientId = createSelector(getPlatformEnvironment, (environment: PlatformEnvironment) => {
    switch (environment) {
        case PlatformEnvironment.Development:
            return 'e2394932-6589-4e72-b430-6cc50150fcfa';
        case PlatformEnvironment.Demo:
            return 'e2394932-6589-4e72-b430-6cc50150fcfa';
        case PlatformEnvironment.Production:
            return 'e2394932-6589-4e72-b430-6cc50150fcfa';
        default:
            return 'e2394932-6589-4e72-b430-6cc50150fcfa';
    }
});
